import { flow, types, getEnv, Instance } from "mobx-state-tree";
import { ZendeskUserResponse } from "../../api-models/response/user/UserResponse";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";

export const emptyZendeskUserResponse: ZendeskUserResponse = {
  email: "",
  exists: false,
  verified: false,
};

export const ZendeskModel = types.model({
  zendeskUserDetails: types.optional(types.frozen<ZendeskUserResponse>(), emptyZendeskUserResponse),
});

export const ZendeskStorageModel = types
  .compose(ZendeskModel, StorageModel)
  .named("ZendeskStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: any) {
        self.zendeskUserDetails = response;
      },
      createZendeskUser: flow(function* createZendeskUser() {
        const endpoint = endpoints.get("zendesk_users");
        yield getEnv(self).api.post(endpoint, {});
        yield self.load();
      }),
    };
  })
  .views((self) => ({
    get endpoint() {
      const endpoint = endpoints.get("zendesk_users");
      return endpoint;
    },
    get isLoading() {
      return self.zendeskUserDetails.email === "";
    },
  }));

export type ZendeskStorage = Instance<typeof ZendeskStorageModel>;
